import type { ProductType } from '~~/server/pageData/productType';

interface ProductTypeResult {
  consolidated_product: string[];
  product_type?: string[];
  master_pdp_type?: string;
}

export function getAnalyticsProductTypeData(productType: ProductType): {
  consolidated_product: string[];
  product_type?: string[];
  master_pdp_type?: string;
} {
  const { isShopTheSet, isConsolidatedPage, isMaster } = productType;

  const result: ProductTypeResult = {
    consolidated_product: isConsolidatedPage && !isShopTheSet ? ['true'] : ['false'],
  };

  if (isShopTheSet) {
    result.product_type = ['shop the set'];
    result.master_pdp_type = 'shop the set';
  } else if (isConsolidatedPage) {
    result.master_pdp_type = 'consolidated';
  } else if (isMaster) {
    result.master_pdp_type = 'collection';
  }

  return result;
}

export default getAnalyticsProductTypeData;
